<template>
  <div>
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="运维人员">
              <a-tree-select
                style="width: 100%"
                :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                :treeData="userTree"
                v-model="queryParam.userId"
                placeholder="请选择运维人员"
                showSearch
                treeNodeFilterProp="title"
              >
              </a-tree-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="维护类型">
              <a-select
                v-model="queryParam.maintenanceType"
                placeholder="请选择维护类型"
                allowClear
              >
                <a-select-option v-for="item in maintenanceTypeOptions" :key="item.value" :value="item.value">
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="填报时间">
              <a-range-picker
                format="YYYY-MM-DD"
                v-model="dates.maintenanceDate"
                :placeholder="['开始时间', '结束时间']"
                @change="onDateChange"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="searchQuery" icon="search" type="primary" ghost>查询</a-button>
      <a-button @click="searchReset" icon="reload">重置</a-button>
      <a-button :disabled="addDisabled" @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="exportXlsWithDynamicName">导出</a-button>
      <a-button :icon="expandAll ? 'minus-square' : 'plus-square'" @click="toggleExpandAll">
        {{ expandAll ? '收起质控措施' : '展开质控措施' }}
      </a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete" />
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域 -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <span slot="qcMeasureSummary" slot-scope="text, record">
          <template v-if="text">
            <!-- 未完整展示时：带 Tooltip -->
            <a-tooltip v-if="!isRowExpanded(text, record.id)" placement="topLeft" :overlayStyle="{ maxWidth: '400px' }" :mouseLeaveDelay="0.1">
              <template slot="title">
                <div style="white-space: pre-line; font-size: 12px; line-height: 1.6;">{{ getAllMeasureText(text, record.st) }}</div>
              </template>
              <div style="display: flex; align-items: center; text-align: left;">
                <div style="flex: 1; min-width: 0;">
                  <div
                    v-for="(line, idx) in getMeasureLines(text, record.id)"
                    :key="idx"
                    style="line-height: 1.5; font-size: 12px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                  >
                    {{ translateMeasureLine(line, record.st) }}
                  </div>
                </div>
                <a-badge
                  :count="'等' + text.split('\n').length + '条'"
                  :numberStyle="{ backgroundColor: '#e6f7ff', color: '#1890ff', boxShadow: 'none', fontSize: '11px', cursor: 'pointer' }"
                  style="margin-left: 6px; flex-shrink: 0;"
                  @click="toggleExpand(record.id)"
                />
              </div>
            </a-tooltip>
            <!-- 已完整展示时：无 Tooltip -->
            <template v-else>
              <div style="text-align: left;">
                <div
                  v-for="(line, idx) in getMeasureLines(text, record.id)"
                  :key="idx"
                  style="line-height: 1.5; font-size: 12px;"
                >
                  {{ translateMeasureLine(line, record.st) }}
                </div>
                <div v-if="text.split('\n').length > 2" style="text-align: center; margin-top: 2px;">
                  <a style="font-size: 12px; color: #1890ff;" @click="collapseRow(record.id)"><a-icon type="up" /> 收起</a>
                </div>
              </div>
            </template>
          </template>
          <span v-else>--</span>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">查看</a>
          <template v-if="getAuth(record.createBy)">
            <a-divider type="vertical" />
            <a @click="handleEdit(record)">编辑</a>
          </template>
          <a-divider type="vertical" />
          <a @click="handleExportSingle(record)">导出</a>
          <template v-if="getAuth(record.createBy)">
            <a-divider type="vertical" />
            <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
              <a>删除</a>
            </a-popconfirm>
          </template>
        </span>
      </a-table>
    </div>

    <!-- 表单区域 -->
    <qc-ledger-drawer ref="modalForm" :pagePath="pagePath" @ok="modalFormOk"></qc-ledger-drawer>
  </div>
</template>

<script>
import QcLedgerDrawer from './modules/QcLedgerDrawer'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin'
import { queryUserTreeList, ajaxGetDictItems } from '@/api/api'
import { downloadFile } from '@/api/manage'

export default {
  name: 'QcLedgerList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    QcLedgerDrawer,
  },
  data() {
    return {
      pagePath: '/om/qc/ledger',
      pageTitle: '质量控制台账',
      addDisabled: false,
      userTree: [],
      maintenanceTypeOptions: [],
      maintenanceTypeMap: {},
      maintenanceTypeStMap: {},
      measureDictMap: {},
      measureDictStMap: {},
      qcLedgerStList: ['21', '31', '32'],
      expandAll: false,
      expandedRows: [],
      currentSt: '',
      isorter: {
        column: 'maintenance_date',
        order: 'desc',
      },
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点名称',
        align: 'center',
        sorter: true,
      },
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          dataIndex: 'maintenanceType',
          colName: 'maintenance_type',
          title: '维护类型',
          align: 'center',
          sorter: true,
          customRender: (text, record) => {
            return this.translateMaintenanceType(text, record.st)
          },
        },
        {
          dataIndex: 'qcMeasureSummary',
          title: '质控措施',
          align: 'center',
          width: 220,
          scopedSlots: { customRender: 'qcMeasureSummary' },
        },
        {
          dataIndex: 'userId_userName',
          colName: 'user_id',
          title: '运维人员',
          align: 'center',
          sorter: true,
        },
        {
          dataIndex: 'maintenanceDate',
          colName: 'maintenance_date',
          title: '填报时间',
          align: 'center',
          sorter: true,
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 180,
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  watch: {
    currentSiteId() {
      var ids = this.getTreeCurrentId()
      this.queryParam.scopeId = ids[1]
      this.queryParam.scope = ids[0]
      if (ids[0] == 1) {
        this.addDisabled = false
        this.queryParam.siteId = ids[1]
        this.spliceColumn(this.siteColumn)
      } else {
        this.addDisabled = true
        this.queryParam.siteId = undefined
        this.spliceColumn(this.siteColumn, 1)
      }
      this.delayLoadData()
    },
  },
  created() {
    this.queryUserTreeList()
    this.syncTreeSt()
  },
  mounted() {
    window.addEventListener('setItem', this.handleTreeStChange)
    this.syncTreeSt()
  },
  beforeDestroy() {
    window.removeEventListener('setItem', this.handleTreeStChange)
  },
  methods: {
    /** 同步站点树类型到列表查询参数 */
    syncTreeSt() {
      this.syncStToQuery(window.localStorage.getItem('treeSt'))
    },
    handleTreeStChange(e) {
      if (e.key === 'treeSt') {
        this.syncTreeSt()
      }
    },
    syncStToQuery(st) {
      if (st) {
        this.currentSt = st
        this.$set(this.queryParam, 'st', st)
        this.loadMaintenanceTypeDict(st)
        this.loadMeasureDict(st)
      } else {
        this.currentSt = ''
        this.$delete(this.queryParam, 'st')
        this.loadAllDicts()
      }
    },
    /** st为空时加载全部质控台账字典，避免列表翻译缺失 */
    loadAllDicts() {
      this.maintenanceTypeOptions = []
      this.maintenanceTypeMap = {}
      this.maintenanceTypeStMap = {}
      this.measureDictMap = {}
      this.measureDictStMap = {}
      this.qcLedgerStList.forEach((st) => {
        this.loadMaintenanceTypeDict(st, st === this.qcLedgerStList[0])
        this.loadMeasureDict(st)
      })
    },
    queryUserTreeList() {
      queryUserTreeList().then((res) => {
        if (res.success) {
          this.userTree = res.result || []
          this.loading = false
        }
      })
    },
    /** 加载维护类型字典 */
    loadMaintenanceTypeDict(st, setOptions = true) {
      let dictCode = 'qc_maintenance_type_st' + st
      ajaxGetDictItems(dictCode).then((res) => {
        if (res.success && res.result) {
          if (setOptions && (this.currentSt === st || (!this.currentSt && st === this.qcLedgerStList[0]))) {
            this.maintenanceTypeOptions = res.result || []
          }
          let map = {}
          res.result.forEach(item => { map[item.value] = item.text })
          this.maintenanceTypeStMap = { ...this.maintenanceTypeStMap, [st]: map }
          this.maintenanceTypeMap = { ...this.maintenanceTypeMap, ...map }
        }
      })
    },
    /** 加载质控措施字典（用于列表翻译） */
    loadMeasureDict(st) {
      let dictCode = 'qc_measure_st' + st
      ajaxGetDictItems(dictCode).then((res) => {
        if (res.success && res.result) {
          let map = {}
          res.result.forEach(item => { map[item.value] = item.text })
          this.measureDictStMap = { ...this.measureDictStMap, [st]: map }
          this.measureDictMap = { ...this.measureDictMap, ...map }
        }
      })
    },
    /** 翻译维护类型显示文本 */
    translateMaintenanceType(value, st) {
      let stMap = this.maintenanceTypeStMap[st] || {}
      return stMap[value] || this.maintenanceTypeMap[value] || value
    },
    onDateChange(value, dateArray) {
      this.queryParam.maintenanceDateStart = dateArray[0]
      this.queryParam.maintenanceDateEnd = dateArray[1]
    },
    exportXlsWithDynamicName() {
      let prefix = this.currentSiteName || ''
      let date = new Date()
      let year = date.getFullYear()
      let month = (date.getMonth() + 1).toString().padStart(2, '0')
      let day = date.getDate().toString().padStart(2, '0')
      let fileName = `${prefix}质控台账${year}${month}${day}`
      this.handleExportXls(fileName)
    },
    handleAdd() {
      let siteId = this.queryParam.siteId
      this.$refs.modalForm.currentSt = this.currentSt
      this.$refs.modalForm.add(siteId)
      this.$refs.modalForm.title = '新增：' + this.pageTitle
      this.$refs.modalForm.disableSubmit = false
    },
    handleEdit(record) {
      this.$refs.modalForm.currentSt = record.st || this.currentSt
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = '编辑：' + this.pageTitle
      this.$refs.modalForm.disableSubmit = false
    },
    handleDetail(record) {
      this.$refs.modalForm.currentSt = record.st || this.currentSt
      this.$refs.modalForm.detail(record)
      this.$refs.modalForm.title = '查看：' + this.pageTitle
      this.$refs.modalForm.disableSubmit = true
    },
    handleExportSingle(record) {
      let dateStr = record.maintenanceDate ? record.maintenanceDate.substring(0, 10).replace(/-/g, '') : ''
      let fileName = '质控台账_' + (record.siteName || '') + '_' + this.translateMaintenanceType(record.maintenanceType, record.st) + '_' + dateStr
      downloadFile(fileName + '.xls', this.pagePath + '/exportSingle', { id: record.id })
    },
    /** 翻译单行措施文本 */
    translateMeasureLine(line, st) {
      let parts = line.split(':')
      let measureCode = parts[0] || ''
      let factorName = parts[1] || ''
      let stMap = this.measureDictStMap[st] || {}
      let measureName = stMap[measureCode] || this.measureDictMap[measureCode] || measureCode
      return measureName + '：' + factorName
    },
    /** 获取全部措施文本（用于 Tooltip） */
    getAllMeasureText(text, st) {
      if (!text) return ''
      return text.split('\n').map(l => this.translateMeasureLine(l, st)).join('\n')
    },
    /** 判断某行是否已展开（超过2条时才需要判断） */
    isRowExpanded(text, recordId) {
      let lines = text.split('\n')
      if (lines.length <= 2) return true
      return this.expandAll || this.expandedRows.includes(recordId)
    },
    /** 获取显示的措施行 */
    getMeasureLines(text, recordId) {
      if (!text) return []
      let lines = text.split('\n')
      if (this.expandAll || this.expandedRows.includes(recordId)) return lines
      return lines.slice(0, 2)
    },
    /** 全局展开/收起 */
    toggleExpandAll() {
      if (this.expandAll) {
        this.expandAll = false
        this.expandedRows = []
      } else {
        this.expandAll = true
      }
    },
    /** 点击等N条展开单行 */
    toggleExpand(recordId) {
      let idx = this.expandedRows.indexOf(recordId)
      if (idx >= 0) {
        this.expandedRows.splice(idx, 1)
      } else {
        this.expandedRows.push(recordId)
      }
    },
    /** 收起单行 */
    collapseRow(recordId) {
      let idx = this.expandedRows.indexOf(recordId)
      if (idx >= 0) this.expandedRows.splice(idx, 1)
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
